/* ============================================================
   SPOTLIGHT BESTSELLER CAROUSEL — vanilla JS, no dependencies
   File: assets/spotlight-bestseller.js
   ============================================================ */

(function () {
  function init(section) {
    const track = section.querySelector('[data-spot-track]');
    const cards = Array.from(section.querySelectorAll('[data-spot-card]'));
    const prev  = section.querySelector('[data-spot-prev]');
    const next  = section.querySelector('[data-spot-next]');
    const dotsContainer = section.querySelector('[data-spot-dots]');

    if (!track || cards.length === 0) return;

    let active = 0;
    const total = cards.length;

    // Build dots
    dotsContainer.innerHTML = '';
    cards.forEach((_, i) => {
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('aria-label', 'Produkt ' + (i + 1));
      btn.addEventListener('click', (e) => { e.preventDefault(); go(i); });
      dotsContainer.appendChild(btn);
    });
    const dots = Array.from(dotsContainer.children);

    function update() {
      cards.forEach((card, i) => {
        let d = i - active;
        if (d >  total / 2) d -= total;
        if (d < -total / 2) d += total;
        card.style.setProperty('--pos', d);
        card.setAttribute('data-pos', d);
      });
      dots.forEach((dot, i) => {
        dot.setAttribute('data-active', i === active ? 'true' : 'false');
      });
    }

    function go(n) {
      active = ((n % total) + total) % total;
      update();
    }

    if (prev) prev.addEventListener('click', (e) => { e.preventDefault(); go(active - 1); });
    if (next) next.addEventListener('click', (e) => { e.preventDefault(); go(active + 1); });

    // Click on a side card brings it to center; click on active card follows its link
    cards.forEach((card, i) => {
      card.addEventListener('click', (e) => {
        if (i !== active) {
          e.preventDefault();
          go(i);
        }
      });
    });

    // Keyboard
    section.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft')  { e.preventDefault(); go(active - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); go(active + 1); }
    });
    section.tabIndex = 0;

    // Touch / swipe — attached to the whole stage, not just the track,
    // so taps on cards or empty area both work. preventDefault on horizontal
    // gestures so the page doesn't pan with the swipe.
    const stage = section.querySelector('[data-spot-stage]') || track;
    let startX = null, startY = null, isSwipe = false;
    stage.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      isSwipe = false;
    }, { passive: true });
    stage.addEventListener('touchmove', (e) => {
      if (startX === null) return;
      const dx = e.touches[0].clientX - startX;
      const dy = e.touches[0].clientY - startY;
      if (!isSwipe && Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 8) {
        isSwipe = true;
      }
      if (isSwipe && e.cancelable) e.preventDefault();
    }, { passive: false });
    stage.addEventListener('touchend', (e) => {
      if (startX === null) return;
      const dx = e.changedTouches[0].clientX - startX;
      if (isSwipe && Math.abs(dx) > 40) {
        go(active + (dx < 0 ? 1 : -1));
      }
      startX = null; startY = null; isSwipe = false;
    });

    update();
  }

  function initAll() {
    document.querySelectorAll('.spot-section').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Shopify Theme Editor: re-init on section reload + block add/select
  document.addEventListener('shopify:section:load', (e) => {
    const sec = e.target.querySelector('.spot-section');
    if (sec) init(sec);
  });
  document.addEventListener('shopify:block:select', (e) => {
    const sec = e.target.closest('.spot-section');
    if (!sec) return;
    const cards = Array.from(sec.querySelectorAll('[data-spot-card]'));
    const idx = cards.findIndex(c => c.contains(e.target) || c === e.target);
    if (idx >= 0) {
      // Trigger same go() by simulating dot click
      const dotBtn = sec.querySelectorAll('[data-spot-dots] button')[idx];
      if (dotBtn) dotBtn.click();
    }
  });
})();
